export const reportHomeRoutes = {
  Revenue: `/revenue`,
  Members: `/members`,
  Leads: `/leads`,
  Events: `/events`,
  Visits: `/visits`,
} as const;
